module.exports = __webpack_public_path__ + "static/classhook-signup-aa85d964cef6b3bd51d7ae9d6f4490aa.jpg";